import React, { useEffect, useState, useMemo } from "react";
import TableCompo from "../Table/TableCompo";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  Box,
  Typography,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Divider,
  useTheme,
  TableBody,
  TextField,
  Button,
  useMediaQuery,
} from "@mui/material";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Stack } from "@mui/material";
import { getAppConfig } from "../../../redux/Configuration/configurationSlice";
import { getTransactionRequest } from "../../../redux/BookingBullion/bookingBullionSlice";
import { getMetals } from "../../../redux/slices/manageMetals";
import FeatureUnavailable from "../../Comman/FeatureUnavailable";
import { MenuItem } from "@mui/material";
import {
  fetchJewellersRequest,
  fetchJewellersSidebarRequest,
} from "../../../redux/JewellerList/JewellerSlice";
import { canShowPermission } from "../Permissions/permissionObject";
import Autocomplete from "@mui/material/Autocomplete";

/** Matches API format used by Get Details — include on every fetch when both dates are set (pagination, search, etc.). */
const formatDateTimeRange = (date, type) => {
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  if (type === "start") return `${year}-${month}-${day}T00:00:00`;
  if (type === "end") return `${year}-${month}-${day}T23:59:59`;
  return null;
};

const BookingTransaction = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("SUCCESS");
  const [open, setOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const configData = useSelector((state) => state.appConfig.configData);
  const package_name = configData.package_name || "";
  
  const decimal =  configData?.decimalPrecision || 4;

  const taxType = configData?.taxtype || "GST";
  
  console.log("From BookingTransaction - taxType", taxType);
  // useEffect(() => {
  //   dispatch(getAppConfig());
  // }, []);

  const invoice = useSelector((state) => state.transactions.invoiceData);
  useEffect(() => {
    if (invoice) {
      setSelectedInvoice(invoice);
    }
  }, [invoice]);

  const [selectedJeweller, setSelectedJeweller] = useState("");
  const { jewellersSidebar = [], loading } = useSelector(
    (state) => state.jeweller,
  );
  console.log("jewellersSidebar in DropdownList:", jewellersSidebar);

  useEffect(() => {
    dispatch(fetchJewellersSidebarRequest());
  }, [dispatch]);

  const handleOpenDialog = (invoiceData) => {
    setSelectedInvoice(invoiceData);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedInvoice(null);
  };
  const [pagination, setPagination] = useState({ page: 0, limit: 10 });
  const { transactionList, transactionTotal, transactionLoading, outstanding } =
    useSelector((state) => state.bookingBullion);
  const data = Array.isArray(transactionList) ? transactionList : [];

  useEffect(() => {
    const payload = {
      status: statusFilter,
      search: { value: search },
      columns: [],
      order: [],
      page: pagination.page + 1,
      limit: pagination.limit,
    };

    if (selectedJeweller) {
      payload.jewellerId = selectedJeweller;
    }
    // optional date filter
    if (startDate && endDate) {
      payload.startDate = formatDateTimeRange(startDate, "start");
      payload.endDate = formatDateTimeRange(endDate, "end");
    }

    dispatch(getTransactionRequest(payload));
  }, [
    dispatch,
    pagination,
    search,
    statusFilter,
    selectedJeweller,
    startDate,
    endDate,
  ]);

  const handleGetDetails = () => {
    if (!startDate || !endDate) {
      toast.error("Please select both start and end dates.");
      return;
    }
    if (startDate && endDate) {
      if (startDate > endDate) {
        toast.error("Start Date cannot be after End Date");
        return;
      }
    }

    dispatch(
      getTransactionRequest({
        status: statusFilter,
        search: { value: search },
        columns: [],
        order: [],
        page: pagination.page + 1,
        limit: pagination.limit,
        ...(selectedJeweller && {
          jewellerId: selectedJeweller,
        }),
        startDate: formatDateTimeRange(startDate, "start"),
        endDate: formatDateTimeRange(endDate, "end"),
      }),
    );
  };

  const handleTableChange = (action, tableState) => {
    switch (action) {
      case "changePage":
        setPagination((prev) => ({ ...prev, page: tableState.page }));
        break;

      case "changeRowsPerPage":
        setPagination({ page: 0, limit: tableState.rowsPerPage });
        break;

      case "search":
        setSearch(tableState.searchText || "");
        setPagination((prev) => ({ ...prev, page: 0 }));
        break;

      default:
        break;
    }
  };
  useEffect(() => {
    dispatch(getMetals({}));
  }, []);

  const [permissions, setPermissions] = useState({});
  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing stored permissions", error);
      }
    }
  }, []);
  const canEdit = canShowPermission(permissions, "instalaxmiPermission", "view");

  const columns = [
    {
      field: "createdAt",
      headerName: "Date",
      render: (val, row) => {
        return row?.createdAt
          ? new Date(row.createdAt).toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
          : "N.A";
      },
    },
    {
      field: "orderType",
      headerName: "Order Type",
      render: (val, row) => (row ? `${row.orderType || ""}` : "N.A"),
    },
    {
      field: "bullion",
      headerName: "Metal",
      render: (val, row) => {
        const bullion = row?.bullion;

        // when bullion not found like SIP / INSTALLMENT
        if (!bullion) {
          return row?.metalName || "N.A";
        }

        const metalName = bullion.metalName || row?.metalName || "";
        const karat = bullion.karat ? `${bullion.karat}K` : "";
        const purity = bullion.purity?.toString() || "";

        const combined = [metalName, karat, purity].filter(Boolean).join(" ");

        return combined || row?.metalName || "N.A";
      },
    },
    {
      field: "weight",
      headerName: "Weight",
      render: (val, row) => {
        return row?.weight != null
          ? Number(row.weight).toFixed(decimal)
          : "N.A";
      },
    },
    {
      field: "metalRate",
      headerName: "Metal Rate",
      render: (val, row) => {
        return row?.rate === 0 || row?.rate == null ? "N.A" : row.rate;
      },
    },
    {
      field: "liveRateWithoutGst",
      headerName: "Live Rate Without GST",
      render: (val, row) => {
        return row?.liveRate?.liveRateWithoutGst != null
          ? Number(row.liveRate.liveRateWithoutGst).toFixed(2)
          : "N.A";
      },
    },
    {
      field: "totalAmountWithGst",
      headerName: "Total Amount With GST",
      render: (val, row) => {
        return row?.liveRate?.totalAmountWithGst != null
          ? Number(row.liveRate.totalAmountWithGst).toFixed(2)
          : "N.A";
      },
    },
    {
      field: "totalValue",
      headerName: "Total Value",
      render: (val, row) => {
        if (row?.convenience_charge > 0) {
          return row.final_amount ?? "N.A";
        }

        if (row?.rate === 0 || row?.rate == null) {
          return "N.A";
        }

        return (row.rate * row.weight).toFixed(2);
      },
    },
    {
      field: "cgst",
      headerName: "CGST",
      render: (val, row) => {
        if (!row?.cgst || row.cgst === 0) return "N.A";

        return Number(row.cgst).toFixed(2);
      },
    },
    {
      field: "sgst",
      headerName: "SGST",
      render: (val, row) => {
        if (!row?.sgst || row.sgst === 0) return "N.A";

        return Number(row.sgst).toFixed(2);
      },
    },
    {
      field: "igst",
      headerName: "IGST",
      render: (val, row) => {
        if (!row?.igst || row.igst === 0) return "N.A";

        return Number(row.igst).toFixed(2);
      },
    },
    {
      field: "tax",
      headerName: taxType === "VAT" ? "Total TAX" : "Total GST",
      render: (val, row) => {
        if (row?.total_tax == null) return "N.A";

        return (
          parseFloat(row?.total_tax || 0) - parseFloat(row?.cess || 0)
        ).toFixed(2);
      },
    },
    {
      field: "cess",
      headerName: "CESS",
      render: (val, row) => {
        if (row?.cess == null) return "N.A";

        return Number(row.cess).toFixed(2);
      },
    },
    {
      field: "total_tax",
      headerName: taxType === "VAT" ? "Total TAX" : "Total GST",
      render: (val, row) => {
        if (!row?.total_tax || row.total_tax === 0) return "N.A";

        return Number(row.total_tax).toFixed(2);
      },
    },
    {
      field: "amount",
      headerName: "Amount",
      render: (val, row) => {
        return row?.final_amount != null
          ? Number(row.final_amount).toFixed(2)
          : "N.A";
      },
    },
    {
      field: "status",
      headerName: "Status",
      render: (val, row) => {
        const status = row.status?.toUpperCase();
        let color;

        switch (status) {
          case "SUCCESS":
            color = "green";
            break;
          case "PENDING":
            color = "blue";
            break;
          default:
            color = "red";
            break;
        }

        const handleStatusClick = () => {
          if (status === "SUCCESS") {
            const transactionId = row?._id;
            if (transactionId) {
              const invoiceUrl = `${window.location.origin}/invoice/${transactionId}`;
              window.open(invoiceUrl, "_blank");
            } else {
              console.warn("Transaction ID is missing in first transaction.");
            }
          } else {
            console.warn("No transactions array found in row.");
          }
        };

        return (
          <span
            style={{
              color,
              fontWeight: "bold",
              cursor: status === "SUCCESS" ? "pointer" : "default",
              textDecoration: status === "SUCCESS" ? "underline" : "none",
            }}
            // onClick={handleStatusClick}
          >
            {status}
          </span>
        );
      },
    },
  ];

  const filteredColumns = useMemo(() => {
    if (taxType === "VAT") {
      return columns.filter(
        (col) => !["cgst", "sgst", "igst"].includes(col.field),
      );
    }

    // GST
    return columns.filter((col) => !["tax", "cess"].includes(col.field));
  }, [taxType, columns]);
  if (configData?.featureToggle?.Booking_Bullion !== true) {
    return <FeatureUnavailable heading="Booking Transaction" />;
  }

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", overflow: "auto", pb: 4 }}>
      <Box
        sx={{
          width: "100%",
          mt: 0,
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          pb: 3,
        }}
      >
        <Box mb={3} px={2} pt={2}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            {(outstanding || []).map((item, index) => (
              <Box
                key={index}
                sx={{
                  flex: 1,
                  minWidth: 280,
                  p: 2,
                  borderRadius: 3,
                  background:
                    item.metalName === "Gold"
                      ? "linear-gradient(135deg, #fff8e1, #F0C040)"
                      : "linear-gradient(135deg, #eceff1, #ccc)",

                  boxShadow: "0 4px 12px rgba(0,0,0,0.10)",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: 700,
                    mb: 1,
                    color: "#263238",
                  }}
                >
                  {item.metalName}-{item.karat}k-{item.purity}
                </Typography>
                <Divider sx={{ my: 1.5 }} />

                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#1565c0",
                  }}
                >
                  Total Outstanding Amount
                </Typography>

                <Typography
                  sx={{
                    fontSize: 22,
                    fontWeight: 700,
                    color: "#0d47a1",
                    mb: 1,
                  }}
                >
                  ₹ {Number(item.totalOutstanding || 0).toFixed(2)}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#ef6c00",
                  }}
                >
                  Total Pending Amount
                </Typography>

                <Typography
                  sx={{
                    fontSize: 22,
                    fontWeight: 700,
                    color: "#e65100",
                  }}
                >
                  ₹ {Number(item.totalPendingAmount || 0).toFixed(2)}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  Total Advance Amount
                </Typography>

                <Typography
                  sx={{
                    fontSize: 22,
                    fontWeight: 700,
                    color: "black",
                  }}
                >
                  ₹ {Number(item.totalAdvanceAmount || 0).toFixed(2)}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        <Typography
          fontWeight={600}
          fontSize={25}
          px={2}
          pt={2}
          fontFamily="Aeonik"
        >
          {/* Transaction Details */}
        </Typography>

        {canEdit && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              ml: 2,
              flexWrap: "wrap",
              background: "#f8f9fc",
              px: 2,
              py: 1,
              borderRadius: "14px",
              border: "1px solid #e0e0e0",
              mb: 2,
              width: "fit-content",
            }}
          >
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 600,
                color: "#555",
                whiteSpace: "nowrap",
              }}
            >
              Select Jeweller
            </Typography>

            <Autocomplete
              size="small"
              options={jewellersSidebar || []}
              getOptionLabel={(option) => option?.jewellerName || ""}
              value={
                jewellersSidebar.find((item) => item.id === selectedJeweller) ||
                null
              }
              onChange={(event, newValue) => {
                setSelectedJeweller(newValue?.id || "");
              }}
              sx={{
                minWidth: 500,

                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  height: 40,
                  backgroundColor: "#fff",

                  "& fieldset": {
                    borderColor: "#d0d7de",
                  },

                  "&:hover fieldset": {
                    borderColor: "#752ADA",
                  },

                  "&.Mui-focused fieldset": {
                    borderColor: "#752ADA",
                  },
                },
              }}
              renderInput={(params) => (
                <TextField {...params} placeholder="Search jeweller..." />
              )}
            />
          </Box>
        )}

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            gap={1.5}
            px={2}
            py={1}
          >
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={setStartDate}
              slotProps={{
                textField: {
                  size: "small",
                  sx: {
                    minWidth: 160,
                    "& .MuiInputBase-root": { height: 36, fontSize: 13 },
                    "& .MuiInputLabel-root": { fontSize: 13 },
                  },
                },
              }}
            />

            <DatePicker
              label="End Date"
              value={endDate}
              onChange={setEndDate}
              slotProps={{
                textField: {
                  size: "small",
                  sx: {
                    minWidth: 160,
                    "& .MuiInputBase-root": { height: 36, fontSize: 13 },
                    "& .MuiInputLabel-root": { fontSize: 13 },
                  },
                },
              }}
            />

            <Button
              variant="outlined"
              fullWidth={isMobile}
              sx={{
                // backgroundColor: "#752ADA",
                height: 36,
                minWidth: 120,
                fontSize: 13,
                textTransform: "none",
                px: 2,
                whiteSpace: "nowrap",
              }}
              onClick={handleGetDetails}
            >
              Get Details
            </Button>
          </Box>
        </LocalizationProvider>

        {/* Status Buttons */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            px: 2,
            pb: 1,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Button
            variant="contained"
            size="small"
            onClick={() => setStatusFilter("SUCCESS")}
            sx={{
              backgroundColor:
                statusFilter === "SUCCESS" ? "#4CAF50" : "#E0E0E0",
              color: statusFilter === "SUCCESS" ? "white" : "black",
              textTransform: "none",
              height: 32,
              fontSize: 12,
              px: 2,
              boxShadow: "none",
            }}
          >
            Success
          </Button>

          <Button
            variant="contained"
            size="small"
            onClick={() => setStatusFilter("PENDING")}
            sx={{
              backgroundColor:
                statusFilter === "PENDING" ? "#2196F3" : "#E0E0E0",
              color: statusFilter === "PENDING" ? "white" : "black",
              textTransform: "none",
              height: 32,
              fontSize: 12,
              px: 2,
              boxShadow: "none",
            }}
          >
            Pending
          </Button>

          <Button
            variant="contained"
            size="small"
            onClick={() => setStatusFilter("CANCELLED")}
            sx={{
              backgroundColor:
                statusFilter === "CANCELLED" ? "#f44336" : "#E0E0E0",
              color: statusFilter === "CANCELLED" ? "white" : "black",
              textTransform: "none",
              height: 32,
              fontSize: 12,
              px: 2,
              boxShadow: "none",
            }}
          >
            Cancel
          </Button>

          <Typography fontSize={12} color="gray">
            Click buttons to filter data.
          </Typography>
        </Box>
        <CardContent sx={{ width: "100%", overflowX: "auto" }}>
          <Box sx={{ width: "100%", overflow: "auto" }}>
            <TableCompo
              columns={filteredColumns}
              data={data}
              totalCount={transactionTotal}
              onTableChange={handleTableChange}
              page={pagination.page}
              limit={pagination.limit}
              loading={transactionLoading}
            />
          </Box>
        </CardContent>
      </Box>
    </Box>
  );
};

export default BookingTransaction;
